import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { makeGetOutgoingEmails } from 'reduxes/slices/outgoing_emails/selectors'

import { css } from 'design'
import { Tooltip } from 'primitives/tooltip'
import { cn } from 'util/cn'

function TimelineStatus({ timeline }) {
  const getOutgoingEmails = useMemo(makeGetOutgoingEmails, [])
  const outgoing_emails = useSelector((state) =>
    getOutgoingEmails(state, { timelineId: timeline.id }),
  )

  const renderEmailStatus = () => {
    if (!outgoing_emails || outgoing_emails.length === 0) return

    return (
      <>
        <Tooltip
          tooltip={
            <dl className={cn(dlStyles())}>
              {outgoing_emails.map((outgoing_email) => {
                return (
                  <React.Fragment key={outgoing_email.id}>
                    <dt style={{ gridColumnStart: 1 }}>
                      {' '}
                      {outgoing_email.handle}
                    </dt>
                    <dd style={{ gridColumnStart: 2 }}>
                      <span className={cn(statusStyles())}>
                        <i className="far fa-envelope" />{' '}
                        {outgoing_email.status}
                      </span>
                      {outgoing_email.delivery_status && (
                        <span style={{ whiteSpace: 'pre-wrap' }}>
                          : {outgoing_email.delivery_status}
                        </span>
                      )}
                    </dd>
                  </React.Fragment>
                )
              })}
            </dl>
          }
        >
          <span
            className={cn(iconStyles())}
            id={'timeline-mail-status-' + timeline.id}
          >
            <i className="far fa-envelope" />
            {outgoing_emails.some((oe) => {
              return oe['delivery_issue?']
            }) && (
              <>
                &nbsp;
                <i className="fas fa-exclamation-triangle" />
              </>
            )}
          </span>
        </Tooltip>
      </>
    )
  }

  return <>{renderEmailStatus()}</>
}

const iconStyles = css({
  fontSize: '8px',
  marginLeft: '$1',
  color: '$grey500',
})

const statusStyles = css({
  textTransform: 'capitalize',
})

const dlStyles = css({
  display: 'grid',
  gridTemplateColumns: 'max-content auto',
  margin: 0,
  padding: 0,
})

TimelineStatus.propTypes = {
  timeline: PropTypes.object.isRequired,
}

export default TimelineStatus
